<template>
  <div class="home">
    <!-- Preloader -->
    <!-- <div id="preloader">
      <div id="loader"></div>
    </div> -->
    <!-- Page-wrapper-Start -->
    <div class="page_wrapper">
      <Header />
      <Banner />
      <!-- <CompLogo /> -->
      <Features />
      <About />
      <CountBox />
      <HowWorks />
      <Testimonials />
      <FAQs />

      <Sliders />
      <DownloadBox />
      <!-- <CompLogo />
      <Newsletter /> -->
      <FooterArea />
      <VideoModal />
      <div class="purple_backdrop"></div>
    </div>
    <!-- Page-wrapper-End -->
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Banner from "@/components/BannerSection.vue";
import CompLogo from "@/components/CompanyLogos.vue";
import Features from "@/components/FeaturesSection.vue";
import About from "@/components/AboutSection.vue";
import CountBox from "@/components/CountBox.vue";
import HowWorks from "@/components/HowItWorks.vue";
import Testimonials from "@/components/Testimonials.vue";
import FAQs from "@/components/FaqsArea.vue";
import Sliders from "@/components/SliderArea.vue";
import DownloadBox from "@/components/DownloadBox.vue";
import Newsletter from "@/components/NewsletterBox.vue";
import FooterArea from "@/components/FooterArea.vue";
import VideoModal from "@/components/VideoBox.vue";

export default {
  name: "Home",
  components: {
    Header,
    Banner,
    CompLogo,
    Features,
    About,
    CountBox,
    HowWorks,
    Testimonials,
    FAQs,
    Sliders,
    DownloadBox,
    Newsletter,
    FooterArea,
    VideoModal,
  },
};


</script>
